const userOrder = {
  header: {
    toolbar: {
      all: 'Todos',
      keyword: 'Palabra clave',
      direct: 'Directo',
      cpi: 'CPI',
      hqr: 'HQR',
    }
  },
  table: {
    adminUserCampaigns: 'Campañas del usuario administrador',
    showing: 'mostrando',
    campaignsOf: 'campañas de',
    found: 'encontrado',
    campaignFrom: 'campaña de',
    nothingFoundBySearch: 'No se encontró nada por búsqueda',
    noCampaignsFound: 'No se encontraron campañas',
    submit: 'Enviar',
    changeVendor: 'Cambiar proveedor'
  },
  messages: {
    messageSent: 'Mensaje enviado correctamente'
  },
  modal: {
    sendMessage: 'Enviar mensaje',
    recordsNotFound: 'Registros No encontrado',
    statusChangeHistory: 'Historial de cambios de estado',
    changeProgress: 'Progreso de la actualización',
  },
  actionsDropdown: {
    updateProgress: 'Progreso de la actualización',
  }
};

export default userOrder;
